/* =========================================================
   VELORIA — theme.js
   Core interactions: drawers, sticky header, animations
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Sticky header shadow on scroll ---------- */
  var header = document.querySelector('[data-sticky-header]');
  if (header) {
    var lastY = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || 0;
      header.classList.toggle('is-scrolled', y > 8);
      lastY = y;
    }, { passive: true });
  }

  /* ---------- Generic drawer system ---------- */
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    var trigger = document.querySelector('[data-drawer-open="' + id + '"]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var focusable = el.querySelector('input, button, a');
    if (focusable) setTimeout(function () { focusable.focus(); }, 250);
  }

  function closeAllDrawers() {
    document.querySelectorAll('[data-drawer].is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    document.querySelectorAll('.cart-drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open');
    });
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    document.querySelectorAll('[aria-expanded="true"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-drawer-open]');
    if (openTrigger) {
      openDrawer(openTrigger.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.matches('[data-drawer-overlay]')) {
      closeAllDrawers();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllDrawers();
  });

  window.Veloria = window.Veloria || {};
  window.Veloria.openDrawer = openDrawer;
  window.Veloria.closeAllDrawers = closeAllDrawers;

  var strings = window.veloriaStrings || {};
  var productCache = {};
  var activeQuickAddHandle = '';

  function isPricePending(cents) {
    var value = Number(cents);
    return Number.isFinite(value) && value <= 0;
  }

  function pricePendingText() {
    return strings.pricePending || 'السعر قريبًا';
  }

  function unavailableUntilPricedText() {
    return strings.unavailableUntilPriced || 'غير متاح للشراء حتى تحديد السعر';
  }

  function formatMoney(cents) {
    var settings = window.veloriaSettings || {};
    var value = Number(cents);
    var format = settings.moneyFormat || '{{amount}}';
    var currency = settings.currency || 'USD';
    var fractionDigits = 2;

    if (!Number.isFinite(value)) value = 0;

    try {
      fractionDigits = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currency
      }).resolvedOptions().maximumFractionDigits;
    } catch (error) {
      fractionDigits = 2;
    }

    function formatAmount(token) {
      var decimals = token.indexOf('no_decimals') > -1 ? 0 : fractionDigits;
      var groupSeparator = ',';
      var decimalSeparator = '.';

      if (token.indexOf('comma_separator') > -1) {
        groupSeparator = '.';
        decimalSeparator = ',';
      } else if (token.indexOf('space_separator') > -1) {
        groupSeparator = ' ';
        decimalSeparator = token.indexOf('period_and_space_separator') > -1 ? '.' : ',';
      } else if (token.indexOf('apostrophe_separator') > -1) {
        groupSeparator = "'";
      }

      var parts = (value / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
      return decimals ? parts[0] + decimalSeparator + parts[1] : parts[0];
    }

    var output = format.replace(/\{\{\s*(amount(?:_[a-z_]+)?)\s*\}\}/g, function (_match, token) {
      return formatAmount(token);
    });
    return output.replace('[amount]', formatAmount('amount'));
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function findVariant(product, variantId) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function setPurchaseButtonState(button, variant, readyLabel) {
    if (!button || !variant) return;
    var pending = isPricePending(variant.price);
    var unavailable = variant.available === false;
    var label = button.querySelector('.btn-text') || button;
    var text = pending
      ? unavailableUntilPricedText()
      : unavailable
        ? (strings.soldOut || 'Sold Out')
        : readyLabel;
    button.setAttribute('data-price-pending', pending ? 'true' : 'false');
    button.disabled = pending || unavailable;
    button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
    setText(label, text);
  }

  function syncQuickAdd() {
    var body = document.querySelector('[data-quick-add-body]');
    var button = body && body.querySelector('[data-qa-add]');
    if (!body || !button || !activeQuickAddHandle) return;
    if (!button.hasAttribute('data-price-pending')) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }
    getProduct(activeQuickAddHandle).then(function (product) {
      if (!product || activeQuickAddHandle !== product.handle) return;
      var variant = findVariant(product, button.getAttribute('data-variant-id'));
      if (!variant) return;
      var price = body.querySelector('[data-qa-price]');
      setText(price, isPricePending(variant.price) ? pricePendingText() : formatMoney(variant.price));
      if (price) price.classList.toggle('price--pending', isPricePending(variant.price));
      setPurchaseButtonState(button, variant, strings.addToCart || 'Add to Cart');
    });
  }

  function handleFromProductLink(link) {
    if (!link) return '';
    var href = link.getAttribute('href') || '';
    var match = href.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function syncWishlistItem(item) {
    var handle = handleFromProductLink(item.querySelector('a.cart-item__title'));
    var button = item.querySelector('.wishlist-item__add');
    if (!handle || !button) return;
    if (!button.hasAttribute('data-price-pending')) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }
    getProduct(handle).then(function (product) {
      if (!product || !product.variants || !product.variants.length) return;
      var variant = product.variants[0];
      var price = item.querySelector('.cart-item__price');
      setText(price, isPricePending(variant.price) ? pricePendingText() : formatMoney(variant.price));
      if (price) price.classList.toggle('price--pending', isPricePending(variant.price));
      setPurchaseButtonState(button, variant, strings.addToCart || 'Add to Cart');
    });
  }

  function syncWishlistItems() {
    document.querySelectorAll('[data-wishlist-list] .wishlist-item').forEach(syncWishlistItem);
  }

  function syncRecentlyViewedCard(card) {
    var handle = handleFromProductLink(card.querySelector('.product-card__title'));
    if (!handle) return;
    getProduct(handle).then(function (product) {
      if (!product) return;
      var price = card.querySelector('.price');
      setText(price, isPricePending(product.price) ? pricePendingText() : formatMoney(product.price));
      if (price) price.classList.toggle('price--pending', isPricePending(product.price));
      card.setAttribute('data-price-pending', isPricePending(product.price) ? 'true' : 'false');
    });
  }

  function syncRecentlyViewedCards() {
    document.querySelectorAll('[data-recently-viewed-grid] .product-card').forEach(syncRecentlyViewedCard);
  }

  function observePriceDrivenContent() {
    var quickAddBody = document.querySelector('[data-quick-add-body]');
    if (quickAddBody) {
      new MutationObserver(syncQuickAdd).observe(quickAddBody, { childList: true });
    }
    var wishlist = document.querySelector('[data-wishlist-list]');
    if (wishlist) {
      new MutationObserver(syncWishlistItems).observe(wishlist, { childList: true });
      syncWishlistItems();
    }
    var recentlyViewed = document.querySelector('[data-recently-viewed-grid]');
    if (recentlyViewed) {
      new MutationObserver(syncRecentlyViewedCards).observe(recentlyViewed, { childList: true });
      syncRecentlyViewedCards();
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-add-open]');
    if (trigger) {
      activeQuickAddHandle = trigger.getAttribute('data-product-handle') || '';
      getProduct(activeQuickAddHandle).then(syncQuickAdd);
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.closest('[data-qa-option]')) setTimeout(syncQuickAdd, 0);
  });

  document.addEventListener('click', function (event) {
    var purchaseButton = event.target.closest('[data-qa-add], .wishlist-item__add');
    if (!purchaseButton) return;
    if (purchaseButton.disabled || purchaseButton.getAttribute('data-price-pending') !== 'false') {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.dispatchEvent(new CustomEvent('veloria:price-pending'));
    }
  }, true);

  window.Veloria.isPricePending = isPricePending;
  window.Veloria.pricePendingText = pricePendingText;
  window.Veloria.unavailableUntilPricedText = unavailableUntilPricedText;
  window.Veloria.formatMoney = formatMoney;

  /* ---------- Scroll reveal animations ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('[data-animate]').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('[data-animate]').forEach(function (el) {
      el.classList.add('in-view');
    });
  }

  /* ---------- Wishlist (localStorage-backed) ---------- */
  var WISHLIST_KEY = 'veloria_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) { return []; }
  }

  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistUI();
  }

  function updateWishlistUI() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-toggle');
      var isActive = list.indexOf(id) > -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-wishlist-toggle');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx > -1) { list.splice(idx, 1); } else { list.push(id); }
    setWishlist(list);
    document.dispatchEvent(new CustomEvent('veloria:wishlist-updated'));
  });

  document.addEventListener('DOMContentLoaded', updateWishlistUI);
  window.Veloria.getWishlist = getWishlist;

  /* ---------- Quantity steppers (shared) ---------- */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn) return;
    var wrapper = stepBtn.closest('[data-qty-wrapper]');
    var input = wrapper.querySelector('input[type="number"]');
    var step = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.min || '1', 10);
    var newVal = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = newVal;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function initPriceProtection() {
    observePriceDrivenContent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceProtection);
  } else {
    initPriceProtection();
  }

})();
